// extracted by mini-css-extract-plugin
export default {"statistics_number":"DashboardTotalCustomer_statistics_number__Mn2qI"};